<template>
  <div class="component">

    <div id="header">

      <h1>Boråspartiers Facebookflöden</h1>

    </div>

    <div>

      <feeds class="center"></feeds>

    </div>

    <div id="footer">

      <br />

      <h1>Val 9 september</h1>
      <p>
        Den 9 september 2018 är val till riksdag, kommunfullmäktige och landstingsfullmäktige.
        <br /><br />
        <strong>Din röst är viktig!</strong>
        <br />
        <br />
        <a href="https://www.val.se/" target="_blank">Information om valet</a>
      </p>

      <br />
      <hr />
      <br />

      <img src="/static/favicon.png" class="logo" />

      <p class="semibold">
        Boråspartiers Facebookflöden är en del av projektet <a href="http://www.bt.se/betaboras/" title="Beta Borås" target="_blank">Beta Borås</a>
      </p>

      <p>
        Inspirerad av <a href="http://www.ekokammaren.se" target="_blank">Ekokammaren</a>
      </p>

    </div>

  </div>
</template>

<script>

import FeedFacebook from '@/components/FeedFacebook.vue'
import Feeds from '@/components/Feeds.vue'


export default {
  components: {
    FeedFacebook,
    Feeds
  },
  data () {
    return {

    }
  },
  props: {
    href: ""
  },
  created: function (){
    //Load Facebook API
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = 'https://connect.facebook.net/sv_SE/sdk.js#xfbml=1&version=v2.12&appId=1196347747065674&autoLogAppEvents=1';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  #header{
    text-align: center;
    background: rgb(65,103,178);
    overflow: auto;
    color: white;
    padding: 20px;
  }

  /*#header *{
    display: inline-block;
  }*/

  #footer{
    text-align: center;
  }

  .logo{
    width: 64px;
  }

  .center{
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/Landing.vue